/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.8
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ServiceAccountDTO
 */
export interface ServiceAccountDTO {
    /**
     * 
     * @type {string}
     * @memberof ServiceAccountDTO
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ServiceAccountDTO
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ServiceAccountDTO
     */
    displayName: string;
    /**
     * 
     * @type {string}
     * @memberof ServiceAccountDTO
     */
    organizationId: string;
    /**
     * 
     * @type {Date}
     * @memberof ServiceAccountDTO
     */
    deactivated?: Date;
    /**
     * 
     * @type {string}
     * @memberof ServiceAccountDTO
     */
    deactivatedBy?: string;
    /**
     * 
     * @type {Date}
     * @memberof ServiceAccountDTO
     */
    created: Date;
    /**
     * 
     * @type {string}
     * @memberof ServiceAccountDTO
     */
    createdBy: string;
    /**
     * 
     * @type {Date}
     * @memberof ServiceAccountDTO
     */
    keyGeneratedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof ServiceAccountDTO
     */
    keyGeneratedBy?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ServiceAccountDTO
     */
    isAdmin: boolean;
}

/**
 * Check if a given object implements the ServiceAccountDTO interface.
 */
export function instanceOfServiceAccountDTO(value: object): value is ServiceAccountDTO {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('displayName' in value) || value['displayName'] === undefined) return false;
    if (!('organizationId' in value) || value['organizationId'] === undefined) return false;
    if (!('created' in value) || value['created'] === undefined) return false;
    if (!('createdBy' in value) || value['createdBy'] === undefined) return false;
    if (!('isAdmin' in value) || value['isAdmin'] === undefined) return false;
    return true;
}

export function ServiceAccountDTOFromJSON(json: any): ServiceAccountDTO {
    return ServiceAccountDTOFromJSONTyped(json, false);
}

export function ServiceAccountDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): ServiceAccountDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'displayName': json['displayName'],
        'organizationId': json['organizationId'],
        'deactivated': json['deactivated'] == null ? undefined : (new Date(json['deactivated'])),
        'deactivatedBy': json['deactivatedBy'] == null ? undefined : json['deactivatedBy'],
        'created': (new Date(json['created'])),
        'createdBy': json['createdBy'],
        'keyGeneratedAt': json['keyGeneratedAt'] == null ? undefined : (new Date(json['keyGeneratedAt'])),
        'keyGeneratedBy': json['keyGeneratedBy'] == null ? undefined : json['keyGeneratedBy'],
        'isAdmin': json['isAdmin'],
    };
}

export function ServiceAccountDTOToJSON(value?: ServiceAccountDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'name': value['name'],
        'displayName': value['displayName'],
        'organizationId': value['organizationId'],
        'deactivated': value['deactivated'] == null ? undefined : ((value['deactivated']).toISOString()),
        'deactivatedBy': value['deactivatedBy'],
        'created': ((value['created']).toISOString()),
        'createdBy': value['createdBy'],
        'keyGeneratedAt': value['keyGeneratedAt'] == null ? undefined : ((value['keyGeneratedAt']).toISOString()),
        'keyGeneratedBy': value['keyGeneratedBy'],
        'isAdmin': value['isAdmin'],
    };
}

